import { Sex } from '@bluefox/models/Patient';
import { Icon } from 'semantic-ui-react';

const SexIconComponent = ({ sex }: { sex?: Sex }) => {
  return <Icon name={sex === Sex.Female ? 'venus' : 'mars'} />;
};

export default SexIconComponent;
